function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import Text from './text';
import { defaultTextProps, defaultTextPropTypes } from './default-text-props';
export default function BodyBase(props) {
  const fontFamily = props.weight === 'medium' ? 'LarsseitMedium' : props.weight === 'bold' ? 'LarsseitBold' : 'LarsseitRegular';
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    fontFamily: fontFamily,
    size: 16,
    lineHeight: 25.6
  }), props.children);
}
BodyBase.defaultProps = { ...defaultTextProps,
  weight: 'regular'
};
BodyBase.propTypes = { ...defaultTextPropTypes,
  weight: PropTypes.oneOf(['regular', 'medium', 'bold'])
};
//# sourceMappingURL=body-base.js.map